module.exports = __webpack_public_path__ + "static/media/gusta-logo.0c1d544e.png";